import React, {useMemo} from 'react';
import {connect} from 'react-redux';
import {visualIvrSteps} from 'app/Components/Block/VisualIVRMenuBlock/utils/constants';
import VisualIvrMenu from 'app/Components/Block/VisualIVRMenuBlock/components/VisualIvrMenu/VisualIvrMenu';
import VisualIvrActionsPage from 'app/Components/Block/VisualIVRMenuBlock/components/VisualIvrActionsPage/VisualIvrActionsPage';

const VisualIVRStepManager = ({
  context,
  contentData,
  currentStep,
  categoryData,
}) => {

  const renderCurrentStep = useMemo(() => {
    const isActionPage = (currentStep === visualIvrSteps.CATEGORY_ACTIONS_PAGE && Object.keys(categoryData).length > 0);
    if (isActionPage) {
      return <VisualIvrActionsPage />;
    }
    return <VisualIvrMenu context={context} contentData={contentData} />;
  }, [currentStep]);

  return (
    <div className='visual-ivr-step-manager'>
      {renderCurrentStep}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentStep: state.VisualIVRSlice.currentStep,
  categoryData: state.VisualIVRSlice.categoryData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VisualIVRStepManager);
